var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiberarOramento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "liberar-or\\xE7amento",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.307,
    height: 18.017,
    viewBox: "0 0 18.307 18.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1705",
    "data-name": "Caminho 1705",
    d: "M18.032,8.992A9.019,9.019,0,1,1,10.8.177a.7.7,0,0,1,.618.815.706.706,0,0,1-.882.549A7.445,7.445,0,0,0,2.969,4.383,7.615,7.615,0,1,0,16.39,10.912a7.478,7.478,0,0,0-.041-3.975,1.729,1.729,0,0,1-.075-.358.676.676,0,0,1,.572-.7.663.663,0,0,1,.771.478c.14.58.254,1.167.354,1.756a8.5,8.5,0,0,1,.061.884",
    transform: "translate(0 0)",
    fill: "#9f0010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1706",
    "data-name": "Caminho 1706",
    d: "M101.539,57.146V54.883A2.548,2.548,0,0,1,99.415,53.8a2.451,2.451,0,0,1-.459-1.632,2.575,2.575,0,0,1,2.593-2.381c0-.386,0-.774,0-1.161a.677.677,0,0,1,.48-.65.644.644,0,0,1,.749.237.99.99,0,0,1,.147.461c.021.366.007.734.007,1.1.236.04.464.064.685.119a2.575,2.575,0,0,1,1.913,2.42.694.694,0,1,1-1.385.048,1.181,1.181,0,0,0-1.195-1.166v2.282a2.558,2.558,0,0,1,2.129,1.1,2.427,2.427,0,0,1,.444,1.637,2.553,2.553,0,0,1-2.59,2.335c0,.357.006.715,0,1.073a1.081,1.081,0,0,1-.067.378.683.683,0,0,1-.746.394.7.7,0,0,1-.568-.672c-.007-.388,0-.776,0-1.176a2.67,2.67,0,0,1-1.412-.4,2.478,2.478,0,0,1-1.183-2.05.684.684,0,0,1,.664-.773.693.693,0,0,1,.719.723,1.135,1.135,0,0,0,1.2,1.1m0-5.957a1.131,1.131,0,0,0-1.057.6,1.143,1.143,0,0,0,1.057,1.691Zm1.414,3.7v2.254a1.136,1.136,0,0,0,1.195-1.183,1.117,1.117,0,0,0-1.195-1.071",
    transform: "translate(-93.227 -45.164)",
    fill: "#9f0010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1707",
    "data-name": "Caminho 1707",
    d: "M199.41,11.743l1.58-1.58c.541-.541,1.079-1.084,1.624-1.621a.677.677,0,0,1,.835-.119.67.67,0,0,1,.319.778.87.87,0,0,1-.208.345q-1.807,1.82-3.625,3.629a.687.687,0,0,1-1.052-.008q-.883-.877-1.76-1.76a.695.695,0,1,1,.986-.97c.429.427.855.857,1.3,1.306",
    transform: "translate(-185.491 -7.849)",
    fill: "#9f0010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberarOramento);
export default __webpack_public_path__ + "static/media/liberar-orçamento.753bbd9ef76f5abea567fa12910a739f.svg";
export { ForwardRef as ReactComponent };